<template>
    <van-popup v-if="inventoryStatisticsPopupShow " :value="inventoryStatisticsPopupShow" z-index="100" :close-on-click-overlay="false"
               :style="{ height: '100vh',width: '100vw', background: 'rgba(0,0,0,.3)' }" overlay-class="custom_popup" position="right">
        <div class="product_cost_detail_wrap" v-loading="loading">
            <div class="product_cost_detail_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon  name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                </div>
            </div>
            <div class="product_cost_detail_bottom">
                <div class="inventory_related_statistics">
                    <ul >
                        <li class="flex_js_wrap ellipsis" v-for="item in tableData">
                            <p class="ellipsis">{{item.name}}×{{item.total_num}}</p>
                            <p class="ellipsis" v-if="userPermission.includes('all') || userPermission.includes('inventory_total_cost')">总价：{{item.total_cost}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </van-popup>
</template>
<script>
import {ProjectManageStockCostDetail} from "@/api/index.js"
export default {
    name: "inventory_statistics",
    components: {

    },
    props: {
        inventoryStatisticsPopupShow: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: ''
        },
        projectId: {
            type: Number,
            default: 0
        },
        userPermission:{
            type: Array,
            default: () => []
        }

    },
    data() {
        return {
            loading: false,
            tableData:[
                {name:'1',total_num:'1',total_cost:'1'}
            ]
        }
    },
    created() {
        console.log(this.type)
        if(this.projectId){

        }
    },
    methods: {
        handleClickClose() {
            this.$emit("update:inventoryStatisticsPopupShow", false)
        },

    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";
</style>
